import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAgreements from '@appStore/selfservice/reducers/agreement.reducer';
import * as fromForms from '@appStore/selfservice/reducers/forms.reducer';
import * as fromBookings from '@appStore/selfservice/reducers/bookings.reducer';

import * as fromRoot from '../../../reducers';

// feature state
export interface SelfServiceState {
  agreements: fromAgreements.State;
  forms: fromForms.State;
  bookings: fromBookings.State;
}

export interface State extends fromRoot.State {
  account: SelfServiceState;
}

// reducers
export const reducers: ActionReducerMap<SelfServiceState> = {
  agreements: fromAgreements.reducer,
  forms: fromForms.reducer,
  bookings: fromBookings.reducer
};

// SelfService
export const getState = createFeatureSelector<SelfServiceState>('selfservice');

// Inskickade blanketter
export const getAgreementState = createSelector(
  getState,
  (state: SelfServiceState) => state.agreements
);

export const getActiveAgreementLinkLoaded = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLinkLoaded
);
export const getActiveAgreementLink = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLink
);
export const getSelfServiceAgreements = createSelector(
  getAgreementState,
  fromAgreements.getSelfServiceAgreements
);
export const getSelfServiceAgreementsLoaded = createSelector(
  getAgreementState,
  fromAgreements.getSelfServiceAgreementsLoaded
);
export const getSelfServiceAgreementCreated = createSelector(
  getAgreementState,
  fromAgreements.getSelfServiceAgreementCreated
);
export const getSelfServiceAgreementCreateId = createSelector(
  getAgreementState,
  fromAgreements.getSelfServiceAgreementCreateId
);

// Blanketter/ Blanketter grupperade
export const getFormsState = createSelector(
    getState,
    (state: SelfServiceState) => state.forms
  );
// export const getForms = createSelector(
//     getFormsState,
//     fromForms.getForms
//   );
// export const getFormsLoaded = createSelector(
//     getFormsState,
//     fromForms.getFormsLoaded
//   );

// Blanketter grupperade 
export const getFormCategories = createSelector(
    getFormsState,
    fromForms.getFormCategories
);
export const getFormCategoriesText = createSelector(
    getFormsState,
    fromForms.getFormCategoriesText
);
export const getFormCategoriesLoaded = createSelector(
    getFormsState,
    fromForms.getFormCategoriesLoaded
);

// Bookings
export const getBookingsState = createSelector(
  getState,
  (state: SelfServiceState) => state.bookings
);

export const getBookingServices = createSelector(
  getBookingsState,
  fromBookings.getBookingServices
);

export const getBookingServicesLoaded = createSelector(
  getBookingsState,
  fromBookings.getBookingServicesLoaded
);

export const getServiceCustomQuestions = createSelector(
  getBookingsState,
  fromBookings.getServiceCustomQuestions
);

export const getServiceCustomQuestionsLoaded = createSelector(
  getBookingsState,
  fromBookings.getServiceCustomQuestionsLoaded
);

export const getSelectedService = createSelector(
  getBookingsState,
  fromBookings.getSelectedService
);

export const getSchedulingPolicy = createSelector(
  getBookingsState,
  fromBookings.getSchedulingPolicy
);

export const getSchedulingPolicyLoaded = createSelector(
  getBookingsState,
  fromBookings.getSchedulingPolicyLoaded
);

export const getStaffs = createSelector(
  getBookingsState,
  fromBookings.getStaffs
);

export const getStaffsLoaded = createSelector(
  getBookingsState,
  fromBookings.getStaffsLoaded
);

export const getStaffsLoading = createSelector(
  getBookingsState,
  fromBookings.getStaffsLoading
);

export  const getStaffAvailability = createSelector(
  getBookingsState,
  fromBookings.getStaffAvailability
);

export const getStaffAvailabilityLoaded = createSelector(
  getBookingsState,
  fromBookings.getStaffAvailabilityLoaded
);

export const getAppointmentCreated = createSelector(
  getBookingsState,
  fromBookings.getAppointmentCreated
);

export const getAppointmentCreating = createSelector(
  getBookingsState,
  fromBookings.getAppointmentCreating
);